export const userDefinedHandlersAndOpts = [
  "defaultLinkedOligoMessage",
  "allowMultipleFeatureDirections",
  "getAdditionalEditAnnotationComps",
  "getAdditionalCreateOpts",
  "getLinkedOligoLink",
  "getCustomAutoAnnotateList",
  "allowPartsToOverlapSelf",
  "allowPrimerBasesToBeEdited",
  "truncateLabelsThatDoNotFit",
  "allPartTags",
  "editTagsLink",
  "readOnly",
  "shouldAutosave",
  "hideSingleImport",
  "beforeAnnotationCreate",
  "disableSetReadOnly",
  "showReadOnly",
  "showCircularity",
  "showMoleculeType",
  "showAvailability",
  "showCicularViewInternalLabels",
  "showGCContentByDefault",
  "GCDecimalDigits",
  "onlyShowLabelsThatDoNotFit",
  "fullscreenMode",
  "maxAnnotationsToDisplay",
  "onNew",
  "onImport",
  "onSave",
  "onSaveAs",
  "alwaysAllowSave",
  "generatePng",
  "onRename",
  "getVersionList",
  "getSequenceAtVersion",
  "onDuplicate",
  "onSelectionOrCaretChanged",
  "beforeSequenceInsertOrDelete",
  "enzymeManageOverride",
  "enzymeGroupsOverride",
  "additionalEnzymes",
  "onDelete",
  "onCopy",
  "autoAnnotateFeatures",
  "autoAnnotateParts",
  "autoAnnotatePrimers",
  "onCreateNewFromSubsequence",
  "onPreviewModeFullscreenClose",
  "onPaste",
  "menuFilter"
];
